import { AppArea, ExperimentConfig, ExperimentName } from '@/funnels/@types'

/**
 * Реестр активных экспериментов: `[appArea][experimentName]` = массив вариантов, где индекс 0 —
 * вариант B (бекендный `treatment() === 1`), 1 — C и так далее. Контроль конфигом не
 * описывается: он и есть базовая схема area.
 *
 * Добавить эксперимент = создать `src/funnels/experiments/web_<name>.ts` и подключить его сюда
 * под каждой area, которую он трогает. Читает реестр `getAppAreaExperimentPart` в
 * `src/funnels/funnels.ts` — там же описано, как ставится экспозиция.
 *
 * NB: в simple-performance-web этот файл генерируется (`npm run generate-experiments-registry`)
 * из содержимого папки. Здесь экспериментов единицы, поэтому реестр ведётся руками; генератор
 * имеет смысл завести, когда их станет заметно больше.
 */
const experimentsConfig: Partial<Record<AppArea, { [key: ExperimentName<string>]: ExperimentConfig[] }>> = {}

export default experimentsConfig
